import { InteractionType, EventSource, UserEvent, ComponentType } from '../UserEventsTypes';

export type MenuSelectEvents =
  | 'SELECT_SMART_FORM_RECENT_ITEM'
  | 'REMOVE_SMART_FORM_RECENT_ITEM'
  | 'SELECT_SMART_FORM_MENU_ITEM';

export const menuSelectEvents: Record<MenuSelectEvents, UserEvent> = {
  SELECT_SMART_FORM_RECENT_ITEM: {
    eventDescription: 'Select Smart Form Recent Item',
    eventKey: 'select-smart-form-recent-item',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  REMOVE_SMART_FORM_RECENT_ITEM: {
    eventDescription: 'Remove Smart Form Recent Item',
    eventKey: 'remove-smart-form-recent-item',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  },
  SELECT_SMART_FORM_MENU_ITEM: {
    eventDescription: 'Select Smart Form Menu Item',
    eventKey: 'select-smart-form-menu-item',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.MUI_SELECT
  }
} as const;
